import { ArrowBack } from "@mui/icons-material";
import { Paper, Tooltip, useTheme } from "@mui/material";
import React from "react";

const BackArrowHeader = ({ onClick }) => {
  const theme = useTheme();
  return (
    <Tooltip
      title="Atrás"
      onClick={onClick}
      sx={{
        display: "flex",
        borderStyle: "solid",
        borderColor: theme.palette.secondary.dark,
        cursor: "pointer",
        marginLeft: 2,
      }}>
      <Paper elevation={2}>
        <ArrowBack
          sx={{
            width: 40,
            height: 40,
          }}
        />
      </Paper>
    </Tooltip>
  );
};

export default BackArrowHeader;
